module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-55.abadba4c.svg";